export default "__VITE_ASSET__JVswt8____"